import React, { useState } from 'react';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage('Thank you! You\'ve been added to our waitlist.');
        setEmail('');
      } else {
        const errorData = await response.json();
        setMessage(errorData.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-background">
        <div className="landing-content">
          <h1 className="landing-title">Coach Cedar</h1>
          <p className="landing-description">
            A Privacy-centric, AI personalized health coach that will actually remember everything about you.
          </p>
          
          <form onSubmit={handleSubmit} className="waitlist-form">
            <div className="form-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="email-input"
                disabled={isSubmitting}
                required
              />
              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Joining...' : 'Join the waitlist'}
              </button>
            </div>
            {message && (
              <div className={`message ${message.includes('Thank you') ? 'success' : 'error'}`}>
                {message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 